// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__3L2KK","control":"styles_control__3cPch","projectTitle":"styles_projectTitle__2jfr4","overlay":"styles_overlay__2J4P-"};